let DateFormatConstant = /** @class */ (() => {
    class DateFormatConstant {
        static DateFormatClientDMY() {
            return "dd/mm/yyyy";
        }
        static DateFormatClientMDY() {
            return "MM/dd/yyyy";
        }
    }
    DateFormatConstant.DateFormat = class {
        static DateFormatDMY() {
            return "DD/MM/YYYY";
        }
        static DateFormatMDY() {
            return "MM/DD/YYYY";
        }
    };
    return DateFormatConstant;
})();
export { DateFormatConstant };
